import * as ActionTypes from 'constants';

export const notifications = (state = [],action) => {
	switch(action.type) {
		case ActionTypes.CLEAR_NOTIFICATIONS:
			return [];
		case ActionTypes.SET_NOTIFICATIONS:
			return [...action.payload.notifications];
		case ActionTypes.NOTIFICATION_CREATED:
			return [
				{...action.payload.notification},
				...state
			];
		default:
		return state;
	}
}



// WEBPACK FOOTER //
// ./src/common/reducers/notifications.js